class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    if (this.swiper) return; // prevent multiple init
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.reviewsslider');
    const pagination = this.querySelector('.swiper-pagination');

    if (!slider) return;

    this.swiper = new Swiper(slider, {
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true, // mobile jump fix
      loop: true,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

      pagination: {
        el: pagination,
        clickable: true,
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('review-slider', ReviewSlider);


/* landing review slider */
class LandReviewSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initSwiper();
  }
  initSwiper() {
    const swiperEl = this.querySelector('.land-reviews-slider');

    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      loop: true,
      spaceBetween: 15,
      slidesPerView: 1.2,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 4
        }
      }
    });
  }
}
customElements.define('land-reviews-slider', LandReviewSlider);

//For Sticky Button

document.addEventListener("scroll", function () {
  const sticky = document.querySelector(".stickybar__main");
  const product = document.querySelector(".autoship__main");

  if (!sticky || !product) return;

  const scrollTop = window.scrollY;
  const foldHeight = window.innerHeight; // first fold = 100vh
  const productTop = product.getBoundingClientRect().top + window.scrollY;

  // Show after 1st fold and hide before product section
  if (scrollTop > foldHeight && scrollTop < productTop) {
    sticky.classList.add("visible");
  } else {
    sticky.classList.remove("visible");
  }
});


/* nutrients Section */
class NutrientsWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const showMoreBtn = this.querySelector(".nutrients_btn");
    const hiddenBlocks = this.querySelectorAll(".show_on_button");

    if (!showMoreBtn) return;

    const btnIconWrap = showMoreBtn.querySelector(".nut_btn_icon");

    showMoreBtn.addEventListener("click", (e) => {
      e.preventDefault();
      hiddenBlocks.forEach(block => block.classList.toggle("visible"));

      if (showMoreBtn.classList.contains("active")) {
        showMoreBtn.classList.remove("active");
        showMoreBtn.querySelector("span").textContent = "Show More";
        // Only toggle icon if it exists
        if (btnIconWrap) btnIconWrap.classList.remove("active");
      } else {
        showMoreBtn.classList.add("active");
        showMoreBtn.querySelector("span").textContent = "Show Less";
        // Only toggle icon if it exists
        if (btnIconWrap) btnIconWrap.classList.add("active");
      }
    });
  }
}

customElements.define('nutrients-widget', NutrientsWidget);

//For Sticky Button

document.addEventListener("scroll", function () {
  const sticky = document.querySelector(".stickybar__main");
  const product = document.querySelector(".autoship__main");

  if (!sticky || !product) return;

  const scrollTop = window.scrollY;
  const foldHeight = window.innerHeight; // first fold = 100vh
  const productTop = product.getBoundingClientRect().top + window.scrollY;

  // Show after 1st fold and hide before product section
  if (scrollTop > foldHeight && scrollTop < productTop) {
    sticky.classList.add("visible");
  } else {
    sticky.classList.remove("visible");
  }
});

// const marquee = new Swiper('.marquee-swiper', {
//   slidesPerView: 'auto',
//   loop: true,
//   freeMode: true,
//   allowTouchMove: false,
//   speed: 8000,
//   autoplay: {
//     delay: 0,
//     disableOnInteraction: false,
//   },
//   freeMode: {
//     enabled: true,
//     momentum: false,
//   },
// });

document.querySelectorAll('.marquee-swiper').forEach((swiperEl) => {
  const speed = parseInt(swiperEl.dataset.speed, 10) || 6000;

  new Swiper(swiperEl, {
    slidesPerView: 'auto',
    loop: true,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    allowTouchMove: false,
    speed,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
});


class CollapsibleTabImg extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (event) => {
      const question = event.target.closest(".question");
      if (!question) return;

      const item = question.closest("li");
      const answer = item.querySelector(".answer");
      const isOpen = item.classList.contains("open");

      this.querySelectorAll(".accordion-custom li").forEach((li) => {
        if (li !== item) {
          li.classList.remove("open");
          this.slideUp(li.querySelector(".answer"));
        }
      });

      if (isOpen) {
        item.classList.remove("open");
        this.slideUp(answer);
      } else {
        item.classList.add("open");
        this.slideDown(answer);
      }
    });
  }

  slideUp(element, duration = 300) {
    if (!element) return;

    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";

    requestAnimationFrame(() => {
      element.style.transition = `height ${duration}ms ease`;
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }

  slideDown(element, duration = 300) {
    if (!element) return;

    element.style.display = "block";

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";

    requestAnimationFrame(() => {
      element.style.transition = `height ${duration}ms ease`;
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  }
}

customElements.define("collapsible-tab-img", CollapsibleTabImg);

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    const productBlock = this.querySelector('.custom-sub-widget');
    const sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    productBlock.appendChild(sellingPlanInput);

    const purchaseOptions = productBlock.querySelectorAll('.purchase-option');
    const subscribeOptionsWrap = productBlock.querySelector('.subscribe-options-wrap');
    const selectElement = productBlock.querySelector('.select__select');
    const subscribeRadio = productBlock.querySelector('#product-subscribe');
    const onetimeRadio = productBlock.querySelector('#product-onetime');

    let sealSubscribeRadio = null;
    let sealOnetimeRadio = null;
    let sealWidgetReady = false;
    let currentSelectedOption = 'subscribe';

    /* ------------------------------
       TOGGLE COMPARE PRICE
    ------------------------------ */

    function toggleComparePrice() {
      const comparePrices = document.querySelectorAll('.price-item--compare-at');

      comparePrices.forEach((price) => {
        if (currentSelectedOption === 'subscribe') {
          price.classList.remove('hidden');
        } else {
          price.classList.add('hidden');
        }
      });
    }

    /* ------------------------------
       OBSERVE SEAL SUBSCRIPTIONS
    ------------------------------ */

    function observeSealWidget() {
      const observer = new MutationObserver((mutations, obs) => {
        sealSubscribeRadio = document.querySelector('.sls-option[data-type="subscription"]');
        sealOnetimeRadio = document.querySelector('.sls-option[data-type="one_time"]');

        if (sealSubscribeRadio && sealOnetimeRadio) {
          sealWidgetReady = true;
          obs.disconnect();

          if (subscribeRadio.checked) {
            sealSubscribeRadio.click();
          } else if (onetimeRadio.checked) {
            sealOnetimeRadio.click();
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => observer.disconnect(), 10000);
    }

    /* ------------------------------
       UPDATE SELLING PLAN
    ------------------------------ */

    function updateSellingPlan(event) {
      sellingPlanInput.value = event.target.value;
      toggleComparePrice();
    }

    /* ------------------------------
       BUTTON DISPLAY
    ------------------------------ */

    function toggleButtonDisplay() {
      const buttonText = document.querySelector('.product-form__button--text');
      const buttonPrice = document.querySelector('.product-form__button--price');

      const stikcySelling = document.querySelector('.product-sticky-selling');
      const stickyRegular = document.querySelector('.product-sticky-regular');

      if (currentSelectedOption === 'subscribe') {
        if (buttonText) buttonText.classList.add('hidden');
        if (buttonPrice) buttonPrice.classList.remove('hidden');
        if (stikcySelling) stikcySelling.classList.remove('hidden');
        if (stickyRegular) stickyRegular.classList.add('hidden');
      } else {
        if (buttonText) buttonText.classList.remove('hidden');
        if (buttonPrice) buttonPrice.classList.add('hidden');
                if (stikcySelling) stikcySelling.classList.add('hidden');
        if (stickyRegular) stickyRegular.classList.remove('hidden');
      }
    }

    /* ------------------------------
       UPDATE TAB
    ------------------------------ */

    function updateTab(selectedOption) {
      currentSelectedOption = selectedOption;

      purchaseOptions.forEach(option => {
        const isSelected = option.dataset.purchaseoption === selectedOption;
        option.classList.toggle('selected', isSelected);
      });

      const contents = productBlock.querySelectorAll('.tab-content');
      contents.forEach(content => {
        content.style.display = content.dataset.content === selectedOption ? 'block' : 'none';
      });

      if (selectedOption === 'subscribe') {
        if(subscribeOptionsWrap) subscribeOptionsWrap.style.display = 'block';
        const selectedValue = selectElement?.value;
        if (selectedValue) sellingPlanInput.value = selectedValue;
        subscribeRadio.checked = true;

        if (sealWidgetReady && sealSubscribeRadio && !sealSubscribeRadio.checked) {
          sealSubscribeRadio.click();
        }
      } else {
        if(subscribeOptionsWrap) subscribeOptionsWrap.style.display = 'none';
        sellingPlanInput.value = '';
        onetimeRadio.checked = true;

        if (sealWidgetReady && sealOnetimeRadio && !sealOnetimeRadio.checked) {
          sealOnetimeRadio.click();
        }
      }

      toggleButtonDisplay();
      toggleComparePrice();
    }

    /* ------------------------------
       PURCHASE OPTION CLICK
    ------------------------------ */

    purchaseOptions.forEach(option => {
      option.addEventListener('click', () => {
        const selected = option.dataset.purchaseoption;
        updateTab(selected);
      });
    });

    /* ------------------------------
       SELLING PLAN SELECT CHANGE
    ------------------------------ */

    if (selectElement) {
      selectElement.addEventListener('change', updateSellingPlan);
    }

    /* ------------------------------
       VARIANT CHANGE (DAWN FIX)
    ------------------------------ */

    const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', (e) => {
        if (e.target.name === 'id') {
          setTimeout(() => {
            toggleButtonDisplay();
            toggleComparePrice();
          }, 50);
        }
      });
    }

    /* ------------------------------
       INITIAL STATE FROM URL
    ------------------------------ */

    const params = new URLSearchParams(window.location.search);
    const purchaseParam = params.get('purchase');

    const initialOption =
      purchaseParam === 'onetime' || purchaseParam === 'subscribe'
        ? purchaseParam
        : 'subscribe';

    updateTab(initialOption);

    /* ------------------------------
       START OBSERVER
    ------------------------------ */

    observeSealWidget();
  }
}

customElements.define('subscription-widget', SubscriptionWidget);
